module.exports = __webpack_public_path__ + "img/product-5-INTAGP.89717864.png";